import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '#app/components/ui/accordion.tsx'
import { Badge } from '#app/components/ui/badge.tsx'
import { Card, CardContent } from '#app/components/ui/card.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { EQUIPMENT_FAQ_ITEMS } from '../equipment-cost-estimator.faq.ts'

export function EquipmentFaq() {
	return (
		<section>
			<div className="flex items-center gap-3">
				<div className="bg-primary/10 flex size-10 items-center justify-center rounded-full">
					<Icon
						name="question-mark-circled"
						size="md"
						className="text-primary"
					/>
				</div>
				<div>
					<Badge variant="secondary" className="mb-1">
						FAQ
					</Badge>
					<h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
						Frequently Asked Questions About Equipment Rentals in DFW
					</h2>
				</div>
			</div>

			<Card className="mt-6">
				<CardContent className="pt-6">
					<Accordion type="single" collapsible>
						{EQUIPMENT_FAQ_ITEMS.map((item, idx) => (
							<AccordionItem key={idx} value={`faq-${idx}`}>
								<AccordionTrigger>{item.q}</AccordionTrigger>
								<AccordionContent>
									<p className="text-muted-foreground">{item.a}</p>
								</AccordionContent>
							</AccordionItem>
						))}
					</Accordion>
				</CardContent>
			</Card>
		</section>
	)
}
